module.exports = __webpack_public_path__ + "static/img/profile1.93d38d00.jpg";